<template>
	<div id="c-entrylist" class="entries-grid">
		<div id="grid" ref="grid" class="c-entries-grid h-100">
		</div>
		<div id="progress">
			<template v-if="skeletonRows > 1">
				<ul v-for="row in skeletonRows" :key="row" class="skeleton-container flex items-center gap-4 pr-4">
					<li class="skeleton skeleton-checkbox ml-4"></li>
					<li class="skeleton skeleton-id"></li>
					<li v-for="col in skeletonColumns" :key="col" class="skeleton-content grow">
						<div class="skeleton" :style="`width: ${Math.random() * 30 + 70}%`"></div>
					</li>
				</ul>
			</template>
			<div class="entries-grid-loading">
				<div>
					<div>
						<i class="icon-refresh icon-spin"></i>
						<span></span>
					</div>
					<div id="progress-bar-container">
						<div id="progress-bar">
							<div id="progress-bar-value"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent, computed, inject } from 'vue';
	import './slickgrid';
	import { isMobileKey } from 'src/utilities/injection-keys';

	export default defineComponent({
		components: {
		},
		props: {
			orgcode: { type: String, required: true },
			formUrlName: { type: String, required: true },
			entryView: { type: String, required: false, default: null },
			entriesAmount: { type: Number, required: false, default: null }
		},
		setup(props) {
			const isMobile = inject(isMobileKey);

			/*
				SKELETON LOADER
				---------------
				A lot of these values are approximate, window width/height is used instead of the grid container, nav sidebar width is ignored, etc. to reduce complexity.
				Skeleton loader doesnt need to be exact as long as it doesn't create too many rows which causes performance issues.
				ROW_HEIGHT & ENTRIES_HEADER_HEIGHT are the only ones that should be fairly accurate
				COL_WIDTH - Rough column width measurement used to determine # of columns to fill screen but flex takes care of spacing them out
				CHECKBOX_ID_GAP_WIDTH - Some space to remove from client width to get a bit more accurate, includes width of .skeleton-checkbox, .skeleton-id 16px space between and 16px space on either side of overall grid
				skeletonRows - Pick lesser of entry amt or approx enough to fill screen
				skeletonColumns - Floor bc exact amount doesn't matter bc they are set to flex grow
			*/
			const ROW_HEIGHT = 35;
			const ENTRIES_HEADER_HEIGHT = isMobile ? 46 : 96;
			const COL_WIDTH = 300;
			const CHECKBOX_ID_GAP_WIDTH = 112;
			const skeletonRows = computed(() => Math.min(props.entriesAmount + 1, Math.ceil((document.documentElement.clientHeight - ENTRIES_HEADER_HEIGHT) / ROW_HEIGHT)));
			const skeletonColumns = computed(() => Math.floor((document.documentElement.clientWidth - CHECKBOX_ID_GAP_WIDTH) / COL_WIDTH));

			return {
				skeletonRows,
				skeletonColumns
			};
		},
		data: vm => {
			return {
			};
		}
	});
</script>

<style lang="scss">
@import '@legacy/Views/Shared/gridview';
/* stylelint-disable-next-line scss/at-import-partial-extension */
@import '@legacy/Scripts/component/slickgrid/slick.grid.scss';

.entries-grid {

	.c-hide-entries-grid {
		visibility: hidden;
	}

	.skeleton {

		&-container {
			height: 35px;
			border: 1px solid var(--border-subtle);
			border-bottom: 0;

			&:first-child,
			&:last-child {
				border-bottom: 1px solid var(--border-subtle);
			}

			&:first-child {
				// line up with boxes in surrounding panes
				height: 41px;
				border-top: 0;
			}
		}

		&-checkbox {
			width: 16px;
			height: 16px;
		}

		&-id {
			width: 32px;
			height: 16px;
		}

		&-content {
			width: 128px;

			div {
				height: 14px;
			}
		}
	}

	.c-progress-no-entries-found .skeleton-container {
		display: none;
	}

	@media print {

		[data-has-entry-detail] & {
			display: none;
		}
	}
}
</style>
